const getters = {
  token: state => state.user.token,
  isLogin: state => state.user.isLogin,
  accountInfo: state => state.user.accountInfo
}
export default getters
